export default function RemoveItemsFromSessionStorage() {
        sessionStorage.removeItem("Search1");
        sessionStorage.removeItem("Search2");
        sessionStorage.removeItem("error");
        sessionStorage.removeItem("info");
        sessionStorage.removeItem("Started");
}